import { render, staticRenderFns } from "./PurchaseSuggestionList.vue?vue&type=template&id=a8c2ce88&"
import script from "./PurchaseSuggestionList.vue?vue&type=script&lang=js&"
export * from "./PurchaseSuggestionList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports